<template>
  <b-col sm="12" lg="12">
    <div class="animated fadeIn">
      <b-card ref="cardRef" class="backClass">
        <div
          style="height: 400px; padding-top: 150px"
          v-if="loadingData"
          class="loading"
        >
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <h4 style="display: inline-block">{{ title }}</h4>
          <small
            style="
              margin-left: 10px;
              font-weight: 600;
              color: #20a8d8;
              font-size: 1em;
            "
          >
            Choose Location for Detail view
          </small>
          <b-form-input
            style="display: inline-block; width: 250px; float: right"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>

          <hr />
          <b-row>
            <template v-for="location in filterItems(locations)">
              <b-col
                lg="6"
                sm="6"
                :key="location.id"
                style="padding: 5px; text-align: center"
              >
                <a
                  class="locationLabels"
                  :href="
                    '#/base/city/?loc=' +
                    location.id +
                    '&city=' +
                    location.location +
                    '&lat=' +
                    location.lat +
                    '&lng=' +
                    location.lng
                  "
                  >{{ location.location }}
                  <span style="color: yellow">({{ location.count }})</span></a
                >
              </b-col>
            </template>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
export default {
  name: "ProfileLocations",
  components: {},
  props: ["locationData", "title", "dFrom", "dTo"],
  data() {
    return {
      searchQuery: "",
      loadingData: true,
      locations: [],
    };
  },
  methods: {
    fetchLocations() {
      let params = {};
      params = {
        date_from: this.dFrom,
        date_to: this.dTo,
        company: this.title,
      };
      this.$http
        .get("api/" + this.$company + "/company/table.php", { params })
        .then(
          (res) => {
            console.log(res.data);
            this.locations = res.data.records;
            this.loadingData = false;
          },
          (err) => {
            console.log(err);
            this.loading = false;
          }
        );
    },
    filterItems: function (locations) {
      var app = this;
      return locations.filter(function (location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.location.match(regex);
      });
    },
  },
  mounted() {
    this.fetchLocations();
    this.loadingData = false;
  },
};
</script>

<style scoped>
.locationLabels {
  padding: 9px;
}
</style>
